<template>
  <div class="entering-exiting-warehouse-details">
    <el-form class="entering-exiting-warehouse-project-form" :rules="enteringExitingWarehouseProjectFormRules"
      ref="enteringExitingWarehouseProjectForm" :model="enteringExitingWarehouseProjectForm">
      <div class="row">
        <div class="sub-title">基本信息</div>
        <div class="row-content base-info">
          <el-form-item label="项目名称" prop="projectName">
            <el-input v-model="enteringExitingWarehouseProjectForm.projectName" :disabled="pageType === 'details'"
              class="white" placeholder="请输入项目名称"></el-input>
          </el-form-item>
          <el-form-item label="WMS编码" prop="wmsCode">
            <el-input v-model="enteringExitingWarehouseProjectForm.wmsCode" :disabled="pageType === 'details'"
              class="white" placeholder="请输入编码"></el-input>
          </el-form-item>
        </div>
      </div>

      <div class="row operate-row">
        <div class="business-type">
          <div class="sub-title">业务类型</div>
          <div class="business-type-list">
            <div class="business-type-name" :class="activeIndex === index ? 'business-type-active' : ''"
              v-for="(item, index) in businessTypeList" :key="index"
              @click="selectBusinessType(item, index, `enteringExitingWarehouseProjectForm${activeIndex + 1}`)">
              {{ item.name }}
              <div class="business-status" :class="`business-status${item.status}`">
                <div class="font10">
                  {{ item.status ? '已开启' : '未开启' }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="operate-row-content">
          <div class="operate-top">
            <el-switch :disabled="pageType === 'details'" v-model="enteringExitingWarehouseProjectForm.businessType"
              active-color="#2E68EA" inactive-color="#EEEEEE" inactive-text="业务开启状态" active-text="（关闭时不会自动清空已填内容）"
              @change="openBusinessSwitch">
            </el-switch>
          </div>
          <el-form :key="`enteringExitingWarehouseProjectForm${activeIndex+1}`"
            :ref="`enteringExitingWarehouseProjectForm${activeIndex + 1}`" :model="enteringExitingWarehouseProjectForm">
            <el-form-item class="outbound-balance" label="出仓结算维度" prop="outboundBalanceDimension" :rules="[
                { required: true, message: '请选择出仓结算维度', trigger: 'blur' },
              ]">
              <el-radio-group v-model="enteringExitingWarehouseProjectForm.outboundBalanceDimension"
                :disabled="pageType === 'details'">
                <el-radio :label="1">提单号</el-radio>
                <el-radio :label="2">出仓编号</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="default-header" label="默认应收抬头" prop="defaultAccountsReceivableHeader" :rules="[
                { required: true, message: '请选择默认应收抬头', trigger: 'change' },
              ]">

              <el-select class="white" :disabled="pageType === 'details'"
                v-model="enteringExitingWarehouseProjectForm.defaultAccountsReceivableHeader" placeholder="请选择默认应收抬头">
                <el-option v-for="item in defaultAccountsReceivableHeaderList.filter(data => data.status)"
                  :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <div class="row-content charging">
              <el-tabs v-model="enteringExitingWarehouseProjectForm.activeName" class="enter-exit-tab">
                <el-tab-pane v-for="(t, index) in tabsList"
                  :key="`${activeIndex + 1}-${enteringExitingWarehouseProjectForm.activeName}-${index}`" :label="t.name"
                  :name="t.key">
                  <div class="table">
                    <el-table ref="table" :data="t.tableData" style="width: 100%" 
                    >
                      <el-table-column v-for="(item, cIndex) in tableTitleList"
                        :key="`${activeIndex + 1}-${enteringExitingWarehouseProjectForm.activeName}-${index}-${cIndex}`"
                        :prop="item.prop" :label="item.label" show-overflow-tooltip :min-width="item.width">
                        <template slot-scope="scope">
                          <div v-if="item.prop === 'sort'">
                            {{ scope.$index + 1 }}
                          </div>
                          <div v-if="item.prop === 'feeName'" class="fee-name">
                            <p>
                              {{ scope.row.feeName }}
                            </p>
                            <el-select v-if="pricingArr.indexOf(scope.row.feeName) !== -1" class="white"
                              :class="(pageType === 'details' || !scope.row.switch)?'disable-input':''"
                              v-model="scope.row.feeBasic" :disabled="pageType === 'details' || !scope.row.switch"
                              placeholder="请选择">
                              <el-option v-for="(item, fIndex) in scope.row.feeBasicList"
                                :key="`${activeIndex + 1}-${enteringExitingWarehouseProjectForm.activeName}-${index}-${cIndex}-${fIndex}`"
                                :label="item.name" :value="item.id"></el-option>
                            </el-select>
                          </div>
                          <div class="currency-system" v-if="item.prop === 'currencySystem'">
                            <el-select class="white"
                              :class="(pageType === 'details' || !scope.row.switch)?'disable-input':''"
                              v-model="scope.row.currencySystem" :disabled="pageType === 'details' || !scope.row.switch"
                              multiple placeholder="请选择" popper-class="select-popover-class">
                              <el-option v-for="(w, wIndex) in scope.row.currencySystemList"
                                :key="`${activeIndex + 1}-${enteringExitingWarehouseProjectForm.activeName}-${index}-${cIndex}-${wIndex}`"
                                :label="w.name" :value="w.id">
                                <el-checkbox v-model="w.checked" :disabled="scope.row.defaultCurrencySystem === w.id"
                                  @click.stop.native @change="handleCheckbox(scope.row, w)">{{ w.name }}</el-checkbox>
                                <span @click.stop class="default-btn">
                                  <span @click="setDefaultCurrencySystem(scope.row, w.id)" class="set-default"
                                    v-if="scope.row.defaultCurrencySystem !== w.id && w.checked ">设为默认</span>
                                  <img v-if="scope.row.defaultCurrencySystem === w.id" class="default-tabs"
                                    src="~assets/images/enter-exit/default-tabs.png">
                                </span>
                              </el-option>
                            </el-select>
                          </div>
                          <div v-if="item.prop === 'unitPriceReceivable'">
                            <div class="receivable-input" v-for="(t, tIndex) in scope.row.currencySystemPriceList"
                              :key="`${activeIndex + 1}-${enteringExitingWarehouseProjectForm.activeName}-${index}-${cIndex}-${tIndex}`">
                              <el-input v-if="scope.row.calculateType !== 2 " v-model="t.unitPriceReceivable"
                                class="white" :class="(pageType === 'details' || !scope.row.switch)?'disable-input':''"
                                :disabled="pageType === 'details' || !scope.row.switch" placeholder="请输入"
                                @input="inputUnitPrice(t, 'unitPriceReceivable', t.unitPriceReceivable)">
                                <span slot="suffix" class="currency-system-unit">
                                  {{ t.id }}
                                </span>
                              </el-input>
                              <div v-else class="receivable-order">
                                <el-input v-if="scope.row.feeBasic !== 1 " v-model="t.unitPriceReceivable" class="white"
                                  :class="(pageType === 'details' || !scope.row.switch)?'disable-input':''"
                                  @input="inputUnitPrice(t, 'unitPriceReceivable', t.unitPriceReceivable)"
                                  :disabled="pageType === 'details' || !scope.row.switch" placeholder="请输入">
                                  <span slot="suffix" class="currency-system-unit">
                                    {{ t.id }}
                                  </span>
                                </el-input>
                                <el-input v-if="scope.row.feeBasic == 1 || pricingArr.indexOf(scope.row.feeName) === -1"
                                  v-model="t.twentyUnitPriceReceivable" class="white cupboard"
                                  @input="inputUnitPrice(t, 'twentyUnitPriceReceivable', t.twentyUnitPriceReceivable)"
                                  :class="(pageType === 'details' || !scope.row.switch)?'disable-input':''"
                                  :disabled="pageType === 'details' || !scope.row.switch" placeholder="请输入">
                                  <span slot="suffix">
                                    <span class="cupboard-unit">20尺柜</span>
                                    <span class="currency-system-unit">{{ t.id }}</span>
                                  </span>
                                </el-input>
                                <el-input v-if="scope.row.feeBasic == 1 || pricingArr.indexOf(scope.row.feeName) === -1"
                                  v-model="t.fortyUnitPriceReceivable"
                                  @input="inputUnitPrice(t, 'fortyUnitPriceReceivable', t.fortyUnitPriceReceivable)"
                                  :class="(pageType === 'details' || !scope.row.switch)?'disable-input':''"
                                  :disabled="pageType === 'details' || !scope.row.switch" class="white cupboard"
                                  placeholder="请输入">
                                  <span slot="suffix">
                                    <span class="cupboard-unit">40尺柜</span>
                                    <span class="currency-system-unit">{{ t.id }}</span>
                                  </span>
                                </el-input>
                              </div>
                            </div>
                          </div>
                          <div v-if="item.prop === 'payableUnitPrice'">
                            <div class="receivable-input" v-for="(t, tIndex) in scope.row.currencySystemPriceList"
                              :key="`${activeIndex + 1}-${enteringExitingWarehouseProjectForm.activeName}-${index}-${cIndex}-${tIndex}`">
                              <el-input v-if="scope.row.calculateType !== 2 " v-model="t.payableUnitPrice"
                                :class="(pageType === 'details' || !scope.row.switch)?'disable-input':''"
                                @input="inputUnitPrice(t, 'payableUnitPrice', t.payableUnitPrice)"
                                :disabled="pageType === 'details' || !scope.row.switch" class="white" placeholder="请输入">
                                <span slot="suffix" class="currency-system-unit">
                                  {{ t.id }}
                                </span>
                              </el-input>
                              <div v-else class="receivable-order">
                                <el-input v-if="scope.row.feeBasic !== 1 " v-model="t.payableUnitPrice"
                                  :class="(pageType === 'details' || !scope.row.switch)?'disable-input':''"
                                  :disabled="pageType === 'details' || !scope.row.switch" class="white"
                                  @input="inputUnitPrice(t, 'payableUnitPrice', t.payableUnitPrice)" placeholder="请输入">
                                  <span slot="suffix" class="currency-system-unit">
                                    {{ t.id }}
                                  </span>
                                </el-input>
                                <el-input v-if="scope.row.feeBasic == 1 || pricingArr.indexOf(scope.row.feeName) === -1"
                                  v-model="t.twentyPayableUnitPrice"
                                  :class="(pageType === 'details' || !scope.row.switch)?'disable-input':''"
                                  :disabled="pageType === 'details' || !scope.row.switch" class="white cupboard"
                                  @input="inputUnitPrice(t, 'twentyPayableUnitPrice', t.twentyPayableUnitPrice)"
                                  placeholder="请输入">
                                  <span slot="suffix">
                                    <span class="cupboard-unit">20尺柜</span>
                                    <span class="currency-system-unit">{{ t.id }}</span>
                                  </span>
                                </el-input>
                                <el-input v-if="scope.row.feeBasic == 1 || pricingArr.indexOf(scope.row.feeName) === -1"
                                  v-model="t.fortyPayableUnitPrice"
                                  :class="(pageType === 'details' || !scope.row.switch)?'disable-input':''"
                                  :disabled="pageType === 'details' || !scope.row.switch" class="white cupboard"
                                  @input="inputUnitPrice(t, 'fortyPayableUnitPrice', t.fortyPayableUnitPrice)"
                                  placeholder="请输入">
                                  <span slot="suffix">
                                    <span class="cupboard-unit">40尺柜</span>
                                    <span class="currency-system-unit">{{ t.id }}</span>
                                  </span>
                                </el-input>
                              </div>
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column 
                        label="操作" 
                        min-width="80"
                        sortable
                        :sort-method="sortMethod"
                      >
                        <template slot-scope="scope">
                          <el-button class="btn-text" v-if="!scope.row.switch" type="text"
                            :disabled="pageType === 'details'" @click="openSubjectDetails(scope.row)">开启</el-button>
                          <el-button class="btn-text" type="text" v-if="scope.row.switch"
                            :disabled="pageType === 'details'" @click="closeSubjectDetails(scope.row)">关闭</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-form>
        </div>
      </div>

      <div class="row">
        <div class="sub-title">存储计费规则</div>
        <div class="row-content">
          <div class="rental-costs-row">
            <el-form-item label="计价方式" prop="feeBasic">
              <el-select class="white" :disabled="pageType === 'details'"
                v-model="enteringExitingWarehouseProjectForm.feeBasic" placeholder="请选择计价方式">
                <el-option v-for="item in feeBasicList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="币制" prop="currencySystem" class="currency">
              <el-select class="white" :disabled="pageType === 'details'"
                v-model="enteringExitingWarehouseProjectForm.currencySystem" placeholder="请选择币值">
                <el-option v-for="item in currencySystemList" :key="item.id" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <div class="add-section" v-if="pageType !== 'details'" @click="addSection">+添加区间</div>
          </div>
          <div class="section-item" v-for="(value, index) in sectionList" :key="index">
            <div class="section">
              <div class="section-title">区间{{ index + 1 }}</div>
              <div class="interval">
                <el-input class="white" v-model="value.begin" disabled></el-input>
                <span class="blank">---</span>
                <el-input class="white" v-model="value.end" :disabled="pageType === 'details' ? true :
                  (index === sectionList.length - 1
                    ? (value.end >= 9999 ? true : false)
                    : false)
                  " @input="inputSectionEnd(index, value.end)" @blur="blurSectionEnd(index, value.end)"></el-input>
              </div>
            </div>
            <div>
              <div class="section-title">计费规则</div>
              <el-input class="white" v-model="value.price" :disabled="pageType === 'details'" placeholder="请输入"
                @input="inputPrice(value, value.price)">
                <span slot="suffix">
                  元/{{ enteringExitingWarehouseProjectForm.feeBasic === 3 ? 'm³' : '吨' }}
                </span>
              </el-input>
            </div>
            <el-button type="text" class="btn-text" v-show="pageType === 'details' ? false : (
              index !== 0 ?
                index === sectionList.length - 1
                : false)
              " @click="deleteSection(index)">删除</el-button>
          </div>
        </div>

        <div class="footer">
          <el-button class="btn-white" @click="closeDialog">
            {{ pageType !== 'details' ? '取消' : '返回' }}
          </el-button>
          <el-button v-if="pageType !== 'details'" class="btn-blue"
            @click="addProject('enteringExitingWarehouseProjectForm', `enteringExitingWarehouseProjectForm${activeIndex + 1}`)">保存</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { debounce, getDecimal, modifyNetTitle } from "common/js/util";
import LookUpMixins from "common/mixins/look-up.js";
import currencyMixins from "common/mixins/currency.js";
import EnteringExitingWarehouse from "models/entering-exiting-warehouse";
export default {
  mixins: [LookUpMixins, currencyMixins],

  data() {
    return {
      // 页面类型
      pageType: '',
      projectId: null,
      enteringExitingWarehouseProjectForm: {
        projectName: '',
        wmsCode: '',
        businessType: 0,
        outboundBalanceDimension: 1,
        activeName: "enter",
        defaultAccountsReceivableHeader: null,
        enterWarehouseCustomsCharges: {
          feeUnit: '票',
          feeName: '报关费',
          switch: false,
          /* 
            1:  固定费用（按单收费）
            2： 根据进仓单数量计算（数量*单价）
            3： 手动填写数量计算（数量*单价）
            4： 手动填写金额（按单收费）
          */
          calculateType: 1,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        enterWarehouseInputFee: {
          feeUnit: '票',
          feeName: '输单费',
          switch: false,
          calculateType: 1,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        enterWarehouseInspectionFee: {
          feeUnit: '票',
          feeName: '报检费',
          switch: false,
          calculateType: 1,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        enterWarehouseLogisticsComprehensiveServiceFee: {
          feeUnit: '票',
          feeName: '物流综合服务费',
          switch: false,
          calculateType: 1,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        enterWarehouseDraggingFeeBasicFee: {
          feeUnit: '车次',
          feeName: '拖卡费基础费',
          switch: false,
          calculateType: 3,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        enterWarehouseCraneFee: {
          feeUnit: '柜',
          feeName: '吊机费',
          switch: false,
          calculateType: 2,
          feeBasic: 1,
          twentyUnitPriceReceivable: '',
          fortyUnitPriceReceivable: '',
          twentyPayableUnitPrice: '',
          fortyPayableUnitPrice: ''
        },
        enterWarehouseBarcodeFee: {
          feeUnit: '柜',
          feeName: '条码费',
          switch: false,
          calculateType: 2,
          feeBasic: 1,
          twentyUnitPriceReceivable: '',
          fortyUnitPriceReceivable: '',
          twentyPayableUnitPrice: '',
          fortyPayableUnitPrice: ''
        },
        enterWarehouseOrderFee: {
          feeUnit: '票',
          feeName: '打单费',
          switch: false,
          calculateType: 1,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        enterWarehouseLandingCharge: {
          feeUnit: '元/柜',
          feeName: '卸货费',
          switch: false,
          calculateType: 2,
          payableUnitPrice: '',
          unitPriceReceivable: '',
          twentyUnitPriceReceivable: '',
          fortyUnitPriceReceivable: '',
          twentyPayableUnitPrice: '',
          fortyPayableUnitPrice: '',
          feeBasic: 1,
          feeBasicList: [
            { id: 1, name: '柜' },
            { id: 2, name: '体积' },
            { id: 3, name: '毛重' },
            { id: 4, name: '净重' },
            { id: 5, name: '件数' }
          ]
        },
        enterWarehouseSortingCharge: {
          feeUnit: '柜',
          feeName: '分拣费',
          switch: false,
          calculateType: 2,
          feeBasic: 1,
          twentyUnitPriceReceivable: '',
          fortyUnitPriceReceivable: '',
          twentyPayableUnitPrice: '',
          fortyPayableUnitPrice: ''
        },
        enterWarehouseDemolitionOrdismantlingFees: {
          feeUnit: '托',
          feeName: '打/拆托费',
          switch: false,
          calculateType: 3,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        enterWarehousePalletFee: {
          feeUnit: '个',
          feeName: '托盘费',
          switch: false,
          calculateType: 3,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        enterWarehouseLabelingFee: {
          feeUnit: '张',
          feeName: '贴标费',
          switch: false,
          calculateType: 3,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        enterWarehouseDocumentationFee: {
          feeUnit: '票',
          feeName: '文件费',
          switch: false,
          calculateType: 1,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },


        exitWarehouseCustomsCharges: {
          feeUnit: '票',
          feeName: '报关费',
          switch: false,
          calculateType: 1,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        exitWarehouseInputFee: {
          feeUnit: '票',
          feeName: '输单费',
          switch: false,
          calculateType: 1,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        exitWarehouseInspectionFee: {
          feeUnit: '票',
          feeName: '报检费',
          switch: false,
          calculateType: 1,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        exitWarehouseLogisticsComprehensiveServiceFee: {
          feeUnit: '票',
          feeName: '物流综合服务费',
          switch: false,
          calculateType: 1,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        exitWarehouseDraggingFeeBasicFee: {
          feeUnit: '车次',
          feeName: '拖卡费基础费',
          switch: false,
          calculateType: 3,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        exitWarehouseRegulatoryFare: {
          feeUnit: '车次',
          feeName: '监管车费',
          switch: false,
          calculateType: 3,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        exitWarehouseCraneFee: {
          feeUnit: '柜',
          feeName: '吊机费',
          switch: false,
          calculateType: 2,
          feeBasic: 1,
          twentyUnitPriceReceivable: '',
          fortyUnitPriceReceivable: '',
          twentyPayableUnitPrice: '',
          fortyPayableUnitPrice: ''
        },
        exitWarehouseBarcodeFee: {
          feeUnit: '柜',
          feeName: '条码费',
          switch: false,
          calculateType: 2,
          feeBasic: 1,
          twentyUnitPriceReceivable: '',
          fortyUnitPriceReceivable: '',
          twentyPayableUnitPrice: '',
          fortyPayableUnitPrice: ''
        },
        exitWarehouseContainerRepairAndCleaningFee: {
          feeUnit: '票',
          feeName: '修洗箱费',
          switch: false,
          calculateType: 4,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        exitWarehouseOrderFee: {
          feeUnit: '票',
          feeName: '打单费',
          switch: false,
          calculateType: 1,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        exitWarehouseLandingCharge: {
          feeUnit: '元/柜',
          feeName: '装货费',
          switch: false,
          calculateType: 2,
          payableUnitPrice: '',
          unitPriceReceivable: '',
          twentyUnitPriceReceivable: '',
          fortyUnitPriceReceivable: '',
          twentyPayableUnitPrice: '',
          fortyPayableUnitPrice: '',
          feeBasic: 1,
          feeBasicList: [
            { id: 1, name: '柜' },
            { id: 2, name: '体积' },
            { id: 3, name: '毛重' },
            { id: 4, name: '净重' },
            { id: 5, name: '件数' }
          ]
        },
        exitWarehouseTallyFee: {
          feeUnit: '元/柜',
          feeName: '理货费',
          switch: false,
          calculateType: 2,
          payableUnitPrice: '',
          unitPriceReceivable: '',
          twentyUnitPriceReceivable: '',
          fortyUnitPriceReceivable: '',
          twentyPayableUnitPrice: '',
          fortyPayableUnitPrice: '',
          feeBasic: 1,
          feeBasicList: [
            { id: 1, name: '柜' },
            { id: 2, name: '体积' }
          ]
        },
        exitWarehouseOrderHandlingFee: {
          feeUnit: '票',
          feeName: '订单操作费',
          switch: false,
          calculateType: 1,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        exitWarehouseSortingCharge: {
          feeUnit: '柜',
          feeName: '分拣费',
          switch: false,
          calculateType: 2,
          feeBasic: 1,
          twentyUnitPriceReceivable: '',
          fortyUnitPriceReceivable: '',
          twentyPayableUnitPrice: '',
          fortyPayableUnitPrice: ''
        },
        exitWarehouseDemolitionOrdismantlingFees: {
          feeUnit: '托',
          feeName: '打/拆托费',
          switch: false,
          calculateType: 3,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        exitWarehousePalletFee: {
          feeUnit: '个',
          feeName: '托盘费',
          switch: false,
          calculateType: 3,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        exitWarehouseLabelingFee: {
          feeUnit: '张',
          feeName: '贴标费',
          switch: false,
          calculateType: 3,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        exitWarehouseCertificateOfOriginFee: {
          feeUnit: '票',
          feeName: '产地证费',
          switch: false,
          calculateType: 1,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },
        exitWarehouseDocumentationFee: {
          feeUnit: '票',
          feeName: '文件费',
          switch: false,
          calculateType: 1,
          payableUnitPrice: '',
          unitPriceReceivable: ''
        },


        feeBasic: 1,
        currencySystem: 'CNY'
      },
      feeBasicList: [
        { id: 1, name: '毛重' },
        { id: 2, name: '净重' },
        { id: 3, name: '体积' }
      ],
      sectionList: [
        {
          begin: 0,
          end: 9999,
          price: ''
        }
      ],
      enteringExitingWarehouseProjectFormRules: {
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        wmsCode: [
          { required: true, message: "请输入编码", trigger: "blur" },
        ],
      },
      // 进仓
      enterWarehouseList: [],
      // 进仓key枚举
      enterWarehouseKeyObj: {
        // 报关费
        'customsDeclarationFee': 'enterWarehouseCustomsCharges',
        // 输单费
        'dataEntryFee': 'enterWarehouseInputFee',
        // 报检费
        'inspectionDeclarationFee': 'enterWarehouseInspectionFee',
        // 物流综合服务费
        'comprehensiveLogisticsServiceFee': 'enterWarehouseLogisticsComprehensiveServiceFee',
        // 拖卡费基础费
        'basicTruckingFee': 'enterWarehouseDraggingFeeBasicFee',
        // 吊机费
        'craneFee': 'enterWarehouseCraneFee',
        // 条码费
        'barcodeFee': 'enterWarehouseBarcodeFee',
        // 打单费
        'documentPrintingFee': 'enterWarehouseOrderFee',
        // 卸货费
        'unloadingFee': 'enterWarehouseLandingCharge',
        // 分拣费
        'sortingFee': 'enterWarehouseSortingCharge',
        // 打/拆托费
        'dePalletizingFee': 'enterWarehouseDemolitionOrdismantlingFees',
        // 托盘费
        'palletFee': 'enterWarehousePalletFee',
        // 贴标费
        'labelingFee': 'enterWarehouseLabelingFee',
        // 文件费
        'documentationFee': 'enterWarehouseDocumentationFee'
      },
      // 出仓
      exitWarehouseList: [],
      // 出仓key枚举
      exitWarehouseKeyObj: {
        // 报关费
        'customsDeclarationFee': 'exitWarehouseCustomsCharges',
        // 输单费
        'dataEntryFee': 'exitWarehouseInputFee',
        // 报检费
        'inspectionDeclarationFee': 'exitWarehouseInspectionFee',
        // 物流综合服务费
        'comprehensiveLogisticsServiceFee': 'exitWarehouseLogisticsComprehensiveServiceFee',
        // 拖卡费基础费
        'basicTruckingFee': 'exitWarehouseDraggingFeeBasicFee',
        // 吊机费
        'craneFee': 'exitWarehouseCraneFee',
        // 条码费
        'barcodeFee': 'exitWarehouseBarcodeFee',
        // 修洗箱费
        'containerRepairAndCleaningFee': 'exitWarehouseContainerRepairAndCleaningFee',
        // 打单费
        'documentPrintingFee': 'exitWarehouseOrderFee',
        // 装货费
        'loadingFee': 'exitWarehouseLandingCharge',
        // 分拣费
        'sortingFee': 'exitWarehouseSortingCharge',
        // 打/拆托费
        'dePalletizingFee': 'exitWarehouseDemolitionOrdismantlingFees',
        // 托盘费
        'palletFee': 'exitWarehousePalletFee',
        // 贴标费
        'labelingFee': 'exitWarehouseLabelingFee',
        // 文件费
        'documentationFee': 'exitWarehouseDocumentationFee',
        // 监管车费
        'supervisedVehicleFee': 'exitWarehouseRegulatoryFare',
        // 理货费
        'cargoHandingFee': 'exitWarehouseTallyFee',
        // 订单操作费
        'orderProcessingFee': 'exitWarehouseOrderHandlingFee',
        // 产地证费
        'certificateOriginFee': 'exitWarehouseCertificateOfOriginFee'
      },
      tabsList: [
        { key: 'enter', name: '进仓费用规则', tableData: [] },
        { key: 'exit', name: '出仓费用规则', tableData: [] }
      ],
      tableTitleList: [
        { label: '序号', prop: 'sort', width: '60' },
        { label: '费用名称', prop: 'feeName', width: '160' },
        { label: '币制', prop: 'currencySystem', width: '160' },
        { label: '应收单价', prop: 'unitPriceReceivable', width: '160' },
        { label: '应付单价', prop: 'payableUnitPrice', width: '160' },
      ],

      // 业务类型列表
      businessTypeList: [],
      businessTypeObj: {
        1: '保税进口分拨',
        2: '非保进口分拨',
        3: '保税出口集拼',
        4: '非保出口集拼',
        5: '转口贸易',
        6: '一日游',
        7: '外协仓',
      },
      activeIndex: 0,

      pricingArr: ['卸货费', '装货费', '理货费'],
      feeBasicObj: {
        1: '元/柜',
        2: '元/立方米',
        3: '元/吨',
        4: '元/吨',
        5: '元/件'
      },
    }
  },

  created() {
    this.pageType = this.$route.query.type;
    this.projectId = Number(this.$route.query.projectId);
    this.initDefaultAccountsReceivableHeaderList()
    if (this.pageType !== 'add') {
      this.initDetails()
      modifyNetTitle(this.pageType === 'mod'?'编辑进出仓项目':'进出仓项目详情')
    } else {
      modifyNetTitle('新增进出仓项目')
      this.initBusinessTypeList()
    }
    this.initSaveProject = debounce(() => {
      this.saveProject()
    }, 800)
  },

  methods: {
    /** 
     * @description 业务类型列表
    */
    initBusinessTypeList() {
      Promise.all([
        EnteringExitingWarehouse.getEnteringWarehouseOperate(),
        EnteringExitingWarehouse.getExitWarehouseOperate()
      ]).then(([enterRes, exitRes]) => {
        this.commonEnterExitWarehouseOperate(enterRes, 1)
        this.commonEnterExitWarehouseOperate(exitRes, 2)

        let enteringExitingWarehouseProjectForm = JSON.parse(JSON.stringify(this.enteringExitingWarehouseProjectForm))
        let tabsList = JSON.parse(JSON.stringify(this.tabsList))
        // 业务类型列表
        this.businessTypeList = [
          { id: 1, name: '保税进口分拨', status: 0, enteringExitingWarehouseProjectForm, tabsList },
          { id: 2, name: '非保进口分拨', status: 0, enteringExitingWarehouseProjectForm, tabsList },
          { id: 3, name: '保税出口集拼', status: 0, enteringExitingWarehouseProjectForm, tabsList },
          { id: 4, name: '非保出口集拼', status: 0, enteringExitingWarehouseProjectForm, tabsList },
          { id: 5, name: '转口贸易', status: 0, enteringExitingWarehouseProjectForm, tabsList },
          { id: 6, name: '一日游', status: 0, enteringExitingWarehouseProjectForm, tabsList },
          { id: 7, name: '外协仓', status: 0, enteringExitingWarehouseProjectForm, tabsList }
        ]
      })
    },

    /** 
     * @description 进出仓操作费列表
     * @param {*} type 1进出；2出仓
    */
    commonEnterExitWarehouseOperate(res, type) {
      let arr = []
      res.result.map(i => {
        let obj = {}
        let keyword = ''
        if (type === 1) {
          keyword = this.enterWarehouseKeyObj[i.keyword]
        } else {
          keyword = this.exitWarehouseKeyObj[i.keyword]
        }
        if (!i.feeBasicEnum) this.enteringExitingWarehouseProjectForm[keyword].feeUnit = i.feeUnit
        obj.keyword = keyword
        obj.realKeyword = i.keyword
        obj.calculateType = i.calculateType
        obj.feeName = i.feeName
        obj.sort = i.sort
        obj.switch = this.enteringExitingWarehouseProjectForm[keyword].switch
        obj.feeBasic = (this.pricingArr.indexOf(i.feeName) !== -1) ? 1 : i.feeBasic
        if (this.pricingArr.indexOf(i.feeName) !== -1) obj.feeBasicList = this.enteringExitingWarehouseProjectForm[keyword].feeBasicList
        obj.feeUnit = i.feeUnit
        obj.currencySystemList = JSON.parse(JSON.stringify(this.currencySystemList))
        obj.defaultCurrencySystem = 'CNY'
        obj.currencySystem = ['CNY']
        obj.currencySystemPriceList = [
          { id: 'CNY', unitPriceReceivable: '', payableUnitPrice: '', twentyUnitPriceReceivable: '', fortyUnitPriceReceivable: '', twentyPayableUnitPrice: '', fortyPayableUnitPrice: '' }
        ]
        if (i.feeBasicEnum) obj.feeBasicEnum = i.feeBasicEnum
        arr.push(obj)
      })
      if (type === 1) {
        this.tabsList[0].tableData = arr
      } else {
        this.tabsList[1].tableData = arr
      }
    },
    
    initDetails() {
      EnteringExitingWarehouse.getEnteringExitingWarehouseProjectDetails(this.projectId).then((res) => {
        if (res.success) {
          let { name, wmsCode, storageFeeJson, businessTypeList } = res.result
          this.enteringExitingWarehouseProjectForm.projectName = name
          this.enteringExitingWarehouseProjectForm.wmsCode = wmsCode
          if (storageFeeJson) {
            this.enteringExitingWarehouseProjectForm.feeBasic = storageFeeJson.feeBasic
            this.enteringExitingWarehouseProjectForm.currencySystem = storageFeeJson.currency
            this.sectionList = storageFeeJson.feeJson
          }
          let arr = []
          businessTypeList.map(b => {
            let obj = {}
            obj.id = b.businessType
            obj.name = this.businessTypeObj[b.businessType]
            obj.status = b.businessTypeStatus?1:0
            obj.enteringExitingWarehouseProjectForm = JSON.parse(JSON.stringify(this.enteringExitingWarehouseProjectForm))
            obj.enteringExitingWarehouseProjectForm.businessType = b.businessTypeStatus
            obj.enteringExitingWarehouseProjectForm.outboundBalanceDimension = b.outboundBalanceDimension
            obj.enteringExitingWarehouseProjectForm.defaultAccountsReceivableHeader = b.receivableBillHeadId ? b.receivableBillHeadId:null
            obj.tabsList = JSON.parse(JSON.stringify(this.tabsList))
            b.feeList.map(i => {
              if (i.feeType === 1) {
                // 进仓
                let enterWarehouseKey = this.enterWarehouseKeyObj[i.keyword]
                obj.tabsList[0].tableData.push(this.commonDetails(i, enterWarehouseKey))
              } else {
                let exitWarehouseKey = this.exitWarehouseKeyObj[i.keyword]
                obj.tabsList[1].tableData.push(this.commonDetails(i, exitWarehouseKey))
              }
            })
            arr.push(obj)
          })
          this.businessTypeList = arr
          this.enteringExitingWarehouseProjectForm = JSON.parse(JSON.stringify(this.businessTypeList[this.activeIndex].enteringExitingWarehouseProjectForm))
          this.tabsList = JSON.parse(JSON.stringify(this.businessTypeList[this.activeIndex].tabsList))
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /* 添加区间 */
    addSection() {
      let length = this.sectionList.length - 1
      let endVal = this.sectionList[length].end
      let obj
      if (endVal != 9999) {
        obj = {
          begin: endVal,
          end: 9999,
          price: '',
        }
      } else {
        obj = {
          begin: this.sectionList[length].begin,
          end: 9999,
          price: '',
        }
      }
      this.sectionList[length].end = ''
      this.sectionList.push(obj)
    },
    /* 删除区间 */
    deleteSection(index) {
      this.sectionList.splice(index, 1);
      let length = this.sectionList.length - 1;
      this.sectionList[length].end = 9999
    },
    /* 限制区间为正整数且不大于9999 */
    inputSectionEnd(index, val) {
      let num = val.toString().match(/^(\+)?\d*/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^(\+)?\d*/g)[0]
        : "";
      if (Number(num) >= 9997) {
        this.sectionList[index].end = 9997
      } else {
        this.sectionList[index].end = Number(num)
      }
    },
    /* 上一个区间的右区间的值带入下一个区间的左区间的值 */
    blurSectionEnd(index, val) {
      let isFlag = false
      this.sectionList.map(i => {
        if (i.begin >= i.end) {
          isFlag = true
        }
      })
      if (this.sectionList[index].end > 9997) {
        this.sectionList[index].end = "";
        this.$message.error('下一个区间的左区间必须小于右区间')
        return
      }
      if (isFlag) {
        this.sectionList[index].end = "";
        this.$message.error('左区间必须小于右区间')
        return
      }
      if (!Number.isNaN(Number(val)) && Number(val) > 0) {
        this.sectionList[index + 1].begin = Number(val);
      } else {
        this.sectionList[index].end = "";
        this.sectionList[index + 1].begin = "";
      }
    },

    /* 新增、编辑项目 */
    addProject(formName, currentFormName) {
      Promise.all([
        // 在then中处理异常
        this.$refs[formName].validate().then(v=>v, e=>e),
        this.$refs[currentFormName].validate().then(v => v, e => e)
      ]).then(([v1, v2]) => {
        if (v1 && v2) {
          // 验证成功
          this.businessTypeList[this.activeIndex].enteringExitingWarehouseProjectForm = this.enteringExitingWarehouseProjectForm
          this.businessTypeList[this.activeIndex].tabsList = this.tabsList

          let nums = 0
          this.businessTypeList.map(i => {
            if (i.status) nums++
          })
          if (nums === 0) return this.$message.error('请至少开启一个业务类型')
          this.initSaveProject()
        }
      })
    },

    saveProject() {
      let isFlagPrice = false
      this.sectionList.map(i => {
        if (i.price === '') {
          isFlagPrice = true
        }
      })
      if (isFlagPrice) {
        return this.$message.error("请输入计费规则");
      }

      let name = this.enteringExitingWarehouseProjectForm.projectName
      let wmsCode = this.enteringExitingWarehouseProjectForm.wmsCode
      let feeBasic = this.enteringExitingWarehouseProjectForm.feeBasic
      let currency = this.enteringExitingWarehouseProjectForm.currencySystem
      let feeJson = this.sectionList
      let storageFeeJson = {
        feeJson,
        feeBasic,
        currency
      }

      let unitPriceReceivableFlag = false
      let payFlag = false
      let businessTypeList = []
      this.businessTypeList.map(b => {
        let obj = {}
        obj.businessType = b.id
        obj.businessTypeStatus = b.status?true:false
        obj.outboundBalanceDimension = b.enteringExitingWarehouseProjectForm.outboundBalanceDimension
        obj.receivableBillHeadId = b.enteringExitingWarehouseProjectForm.defaultAccountsReceivableHeader
        obj.feeList = []
        b.tabsList.map(i => {
          i.tableData.map(j => {
            let obj2 = {}
            obj2.feeType = i.key === 'enter'?1:2
            obj2.calculateType = j.calculateType
            obj2.keyword = j.realKeyword
            obj2.feeName = j.feeName
            obj2.feeBasic = j.feeBasic
            if (j.feeBasicList) {
              obj2.feeBasicEnum = []
              j.feeBasicList.map(f => {
                obj2.feeBasicEnum.push(f.id)
              })
            } else {
              obj2.feeBasicEnum = null
            }
            obj2.feeUnit = j.calculateType === 2 ? this.feeBasicObj[j.feeBasic] :j.feeUnit
            obj2.sort = j.sort
            obj2.status = j.switch
            obj2.feeJson = []
            j.currencySystemPriceList.map(p => {
              if (j.calculateType === 2) {
                if (j.feeBasic === 1) {
                  let twentyPayableUnitPrice = p.twentyPayableUnitPrice
                  let twentyUnitPriceReceivable = p.twentyUnitPriceReceivable
                  let fortyUnitPriceReceivable = p.fortyUnitPriceReceivable
                  let fortyPayableUnitPrice = p.fortyPayableUnitPrice
                  let twentyObj = {currency: p.id, defaultCurrency: j.defaultCurrencySystem === p.id?true:false, feeBasicName: '20尺柜', payableUnitPrice: twentyPayableUnitPrice, receivableUnitPrice: twentyUnitPriceReceivable }
                  let fortyObj =  {currency: p.id, defaultCurrency: j.defaultCurrencySystem === p.id?true:false, feeBasicName: '40尺柜', payableUnitPrice: fortyPayableUnitPrice, receivableUnitPrice: fortyUnitPriceReceivable }
                  obj2.feeJson.push(twentyObj)
                  obj2.feeJson.push(fortyObj)
                  if (j.switch) {
                    if ((!twentyUnitPriceReceivable && twentyUnitPriceReceivable != 0) || (!fortyUnitPriceReceivable && fortyUnitPriceReceivable != 0)) {
                      unitPriceReceivableFlag = true
                    }
                    if ((!twentyPayableUnitPrice && twentyPayableUnitPrice != 0) || (!fortyPayableUnitPrice && fortyPayableUnitPrice != 0)) {
                      payFlag = true
                    }
                  }
                } else {
                  let payableUnitPrice = p.payableUnitPrice
                  let receivableUnitPrice = p.unitPriceReceivable
                  let defaultObj = { currency: p.id, defaultCurrency: j.defaultCurrencySystem === p.id ? true : false, payableUnitPrice, receivableUnitPrice }
                  obj2.feeJson.push(defaultObj)

                  if (j.switch) {
                    if (!receivableUnitPrice && receivableUnitPrice != 0) {
                      unitPriceReceivableFlag = true
                    }
                    if (!payableUnitPrice && payableUnitPrice != 0) {
                      payFlag = true
                    }
                  }
                }
              } else {
                let payableUnitPrice = p.payableUnitPrice
                let receivableUnitPrice = p.unitPriceReceivable
                let defaultObj = { currency: p.id, defaultCurrency: j.defaultCurrencySystem === p.id ? true : false, payableUnitPrice, receivableUnitPrice }
                obj2.feeJson.push(defaultObj)

                if (j.switch) {
                  if (!receivableUnitPrice && receivableUnitPrice != 0) {
                    unitPriceReceivableFlag = true
                  }
                  if (!payableUnitPrice && payableUnitPrice != 0) {
                    payFlag = true
                  }
                }
              }
            })
            obj.feeList.push(obj2)
          })
        })
        businessTypeList.push(obj)
      })


      if (unitPriceReceivableFlag) {
        return this.$message.error("应收单价不能为空");
      }
      if (payFlag) {
        return this.$message.error("应付单价不能为空");
      }

      let data = {
        name,
        wmsCode,
        businessTypeList,
        storageFeeJson
      };
      if (this.projectId) {
        data.id = this.projectId;
        EnteringExitingWarehouse.postModEnteringExitingWarehouseProject(this.projectId, data).then((res) => {
          if (res.success) {
            this.$message.success("编辑成功");
            this.closeDialog()
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        EnteringExitingWarehouse.postAddEnteringExitingWarehouseProject(data).then((res) => {
          if (res.success) {
            this.$message.success("新增成功");
            this.closeDialog()
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },

    commonDetails(i, key) {
      let obj = {}
      obj.switch = i.status
      obj.sort = i.sort
      obj.calculateType = i.calculateType
      obj.feeBasic = i.feeBasic
      obj.feeUnit = i.feeUnit
      obj.keyword = key
      obj.realKeyword = i.keyword
      obj.feeName = i.feeName
      if (this.pricingArr.indexOf(i.feeName) !== -1) obj.feeBasicList = this.enteringExitingWarehouseProjectForm[key].feeBasicList
      
      obj.currencySystem = []
      obj.currencySystemPriceList = []
      obj.currencySystemList = JSON.parse(JSON.stringify(this.currencySystemList))
      let currencySystemPriceListObj = []
      i.feeJson.map((j, jIndex) => {
        if(obj.currencySystem.indexOf(j.currency) === -1) {
          if (j.defaultCurrency) {
            obj.currencySystem.unshift(j.currency)
          } else {
            obj.currencySystem.push(j.currency)
          }
        }
        if (j.defaultCurrency) obj.defaultCurrencySystem = j.currency
          let obj2 = {}
          obj2.id = j.currency
          obj2.unitPriceReceivable = ''
          obj2.payableUnitPrice = ''
          obj2.twentyUnitPriceReceivable = ''
          obj2.fortyUnitPriceReceivable = ''
          obj2.twentyPayableUnitPrice = ''
          obj2.fortyPayableUnitPrice = ''
          if (i.calculateType === 2) {
            if (i.feeBasic === 1) {
              if (currencySystemPriceListObj.indexOf(j.currency) === -1) {
                obj2.twentyUnitPriceReceivable =  j.receivableUnitPrice
                obj2.twentyPayableUnitPrice = j.payableUnitPrice
                obj2.fortyUnitPriceReceivable = i.feeJson[jIndex+1].receivableUnitPrice
                obj2.fortyPayableUnitPrice = i.feeJson[jIndex + 1].payableUnitPrice
                currencySystemPriceListObj.push(j.currency)
                obj.currencySystemPriceList.push(obj2)
              }
            } else {
              obj2.unitPriceReceivable = j.receivableUnitPrice
              obj2.payableUnitPrice = j.payableUnitPrice
              obj.currencySystemPriceList.push(obj2)
            }
            
          } else {
            obj2.unitPriceReceivable = j.receivableUnitPrice
            obj2.payableUnitPrice = j.payableUnitPrice
            obj.currencySystemPriceList.push(obj2)
          }
        })


      obj.currencySystemList.map(i => {
        if (obj.currencySystem.indexOf(i.id) !== -1) {
          i.checked = true
        } else {
          i.checked = false
        }
      })
      return obj
    },

    closeDialog() {
      if (this.pageType !== 'details') {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: '/base-info/project-manage/entering-exiting-warehouse/entering-exiting-warehouse-list',
        })
      }
    },

    inputPrice(row, num) {
      row.price = getDecimal(num)
    },

    /** 
     * @description 选择业务类型
    */
    selectBusinessType(row, index, formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.businessTypeList[this.activeIndex].enteringExitingWarehouseProjectForm = this.enteringExitingWarehouseProjectForm
          this.businessTypeList[this.activeIndex].tabsList = this.tabsList
          this.$nextTick(() => {
            this.activeIndex = index
            row.enteringExitingWarehouseProjectForm.businessType = row.status ? true : false
            row.enteringExitingWarehouseProjectForm.projectName = this.enteringExitingWarehouseProjectForm.projectName
            row.enteringExitingWarehouseProjectForm.wmsCode = this.enteringExitingWarehouseProjectForm.wmsCode
            this.enteringExitingWarehouseProjectForm = JSON.parse(JSON.stringify(row.enteringExitingWarehouseProjectForm))
            this.tabsList = JSON.parse(JSON.stringify(row.tabsList))
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    openBusinessSwitch(v) {
      this.businessTypeList[this.activeIndex].status = v ? 1 : 0
    },

    /** 
     * @description 币值下拉框多选
    */
    handleCheckbox(row, item) {
      item.checked
        ? (row.currencySystem.includes(item.id) ? '' : row.currencySystem.push(item.id))
        : (row.currencySystem = row.currencySystem.filter(
          i => i !== item.id
        ));
      if (item.checked) {
        let obj =
          { id: item.id, unitPriceReceivable: '', payableUnitPrice: '', twentyUnitPriceReceivable: '', fortyUnitPriceReceivable: '', twentyPayableUnitPrice: '', fortyPayableUnitPrice: '' }
        let currencySystemObj = row.currencySystemPriceList.find(i => { return i.id === item.id})
        if (currencySystemObj === undefined) {
          row.currencySystemPriceList.push(obj)
        }
      } else {
        row.currencySystemPriceList = row.currencySystemPriceList.filter(
          i => i.id !== item.id
        )
      }
    },

    /** 
     * @description 设置默认币值
    */
    setDefaultCurrencySystem(row, id) {
      row.defaultCurrencySystem = id
      row.currencySystem.unshift(id)
      row.currencySystem = row.currencySystem.reduce((prev, curr) => prev.includes(curr) ? prev : [...prev, curr], []);
    },

    openSubjectDetails(row) {
      row.switch = true
    },

    closeSubjectDetails(row) {
      row.switch = false
      row.currencySystemPriceList.map(i => {
        i.payableUnitPrice = ''
        i.unitPriceReceivable = ''
        i.twentyUnitPriceReceivable = ''
        i.fortyUnitPriceReceivable = ''
        i.twentyPayableUnitPrice = ''
        i.fortyPayableUnitPrice = ''
      })
    },

    inputUnitPrice(t, key, val) {
      t[key] = getDecimal(val)
    },

    sortMethod(a, b, sortOrder) {
      let aNumber = a.switch?1:0
      let bNumber = b.switch?1:0
      return aNumber - bNumber
    }
  }
}
</script>

<style lang='scss'>
.entering-exiting-warehouse-details {
  .entering-exiting-warehouse-project-form {
    .row {
      background: #fff;
      border-radius: 8px;
      margin-bottom: 20px;

      .sub-title {
        height: 52px;
        line-height: 52px;
        border-bottom: 1px solid #eee;
        padding-left: 32px;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }

      .row-content {
        padding: 20px 32px 16px 32px;

        .el-form-item {
          width: 294px;
          box-sizing: border-box;

          .el-form-item__label {
            line-height: 28px;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
          }
        }
      }

      .base-info {
        display: flex;

        .el-form-item:first-of-type {
          margin-right: 93px;
        }
      }

      .charging {
        padding: 20px 32px;
        box-sizing: border-box;
        .enter-exit-tab {
          .el-tabs__item {
            font-family: 'PingFang SC-Regular';
            font-weight: 400;
            font-size: 16px;
            color: #999999;
          }
          .el-tabs__item:hover,
          .el-tabs__item.is-active {
            color: #2E68EA;
          }
          .el-tabs__active-bar {
            background-color: #2E68EA;
          }
          .el-tabs__nav-wrap::after {
            height: 1px;
          }
          .table {
            .el-table .el-table__body-wrapper .el-table__body tr,
            .el-table .el-table__body-wrapper .el-table__body tr td,
            .el-table .el-table__body-wrapper .el-table__body tr td .cell {
              height: inherit;
              min-height: 42px;
            }
            .el-table .el-table__body-wrapper .el-table__body tr td .cell {
              padding-top: 7px;
              padding-bottom: 7px;
              box-sizing: border-box;
              line-height: 1;
              display: flex;
              justify-content: flex-start;
              align-items: center;
            }
            .el-table .el-table__body-wrapper {
              overflow-x: auto;
            }
            .currency-system {
              width: 148px;
              min-height: 32px;
              .el-select__tags {
                .el-tag--small {
                  padding: 0px 4px;
                }
                .el-tag {
                  display: flex;
                  justify-content: flex-start;
                  border-color: #F5F7FA;
                  background-color: #F5F7FA;
                  .el-tag__close {
                    display: none;
                  }
                }
                .el-tag:first-of-type {
                  padding-left: 0px;
                  &::before {
                    background: url('~assets/images/enter-exit/default.png') no-repeat;
                    content: '';
                    display: block;
                    width: 18px;
                    height: 22px;
                  }
                  .el-select__tags-text {
                    padding-left: 4px;
                  }
                }
              }
            }
            .receivable-input {
              display: flex;
              flex-direction: column;
              margin-top: 4px;
              .el-input {
                width: 140px;
                box-sizing: border-box;
                .el-input__inner {
                  padding-left: 7px;
                  padding-right: 34px;
                }
                .el-input__suffix {
                  height: 30px;
                  line-height: 30px;
                  top: 1px;
                  right: 1px;
                  font-family: 'PingFang SC-Regular';
                  font-weight: 400;
                  font-size: 12px;
                  color: #CCCCCC;
                  .el-input__suffix-inner {
                    height: 100%;
                    display: inline-block;
                  }
                  .currency-system-unit {
                    height: 100%;
                    display: inline-block;
                    padding-right: 2px;
                    padding-left: 2px;
                    background: #F9F9F9;
                    border-radius: 0px 4px 4px 0px;
                    border-left: 1px solid #EBEEF5;
                    
                  }
                }
              }
              .receivable-order {
                display: flex;
                flex-direction: column;
                .el-input {
                  margin-top: 4px;
                  .cupboard-unit {
                    margin-right: 7px;
                  }
                }
                .el-input:first-child {
                  margin-top: 0px;
                }
                .cupboard {
                  .el-input__inner {
                    padding-right: 80px;
                  }
                }
              }
            }
            .receivable-input:first-child {
              margin-top: 0px;
            }
            .fee-name {
              .el-select {
                width: 140px;
                box-sizing: border-box;
                margin-top: 9px;
              }
            }
            .disable-input {
              .el-input__inner:hover {
                border-color: #EBEEF5;
              }
              .el-input__inner,
              .el-input.is-disabled .el-input__inner {
                background: #f9f9f9;
              }
            }
          }
        }

        .sub-label {
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          padding-left: 3px;
          margin-bottom: 17px;
          border-left: 3px solid #2E68EA;
        }
      }

      .rental-costs-row {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;

        .el-form-item__label {
          float: none;
          line-height: 32px !important;
        }

        .el-form-item__content {
          margin-left: 0px !important;

          .el-select {
            width: 100%;
          }
        }
        .currency {
          margin-left: 93px;
        }

        .add-section {
          cursor: pointer;
          margin-top: 38px;
          color: #2E68EA;
          font-size: 12px;
          font-weight: 400;
          margin-left: 20px;
        }
      }

      .section-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 27px;

        .section-title {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          margin-bottom: 10px;
        }

        .el-input.white {
          width: 294px;
        }

        .el-input.white .el-input__suffix {
          top: 9px;
          right: 10px;
        }

        .el-input--suffix .el-input__inner {
          padding-right: 50px;
        }

        .btn-text {
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          font-weight: 400;
          color: #2E68EA;
          margin-left: 19px;
          cursor: pointer;
        }

        .section {
          margin-right: 93px;

          .interval {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .blank {
              padding: 0 10px;
            }

            .el-input {
              width: 130px;
            }
          }
        }
      }

      .footer {
        height: 66px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .operate-row {
      display: flex;
      justify-content: flex-start;

      .business-type {
        width: 301px;
        flex-shrink: 0;
        box-sizing: border-box;
        border-right: 1px solid #eee;

        .sub-title {
          border: none;
        }

        .business-type-list {
          padding: 0px 10px;

          .business-type-name {
            height: 46px;
            font-size: 16px;
            color: #333333;
            padding: 0px 20px;
            font-family: "PingFang SC-Regular";
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-radius: 4px;
            cursor: pointer;

            .business-status {
              width: 40px;
              height: 20px;
              background: #F5F5F5;
              border-radius: 4px 4px 4px 4px;

              .font10 {
                transform-origin: 28px 28px;
              }
            }

            .business-status0 {
              color: #333333;
              background: #F5F5F5;
            }

            .business-status1 {
              color: #22A979;
              background: rgba($color: #22A979, $alpha: 0.12);
            }
          }

          .business-type-active {
            color: #2E68EA;
            background: rgba($color: #F2F4F8, $alpha: 0.5);
          }
        }
      }

      .operate-row-content {
        flex: 1;
        width: calc(100% - 301px);
        .operate-top {
          height: 52px;
          padding: 0px 20px 0px 32px;
          border-bottom: 1px dashed #eee;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .el-switch {

            .el-switch__label,
            .el-switch__label.is-active {
              color: #333;
              font-weight: 400;
              font-family: "PingFang SC-Regular";

              span {
                font-size: 16px;
              }
            }

            .el-switch__label--right,
            .el-switch__label--right.is-active {
              color: #999;

              span {
                font-size: 12px;
              }
            }
          }

          .btn-white,
          .btn-blue {
            width: 56px;
            height: 32px;
            padding: 0;
            font-family: "PingFang SC-Regular";
            border-radius: 4px 4px 4px 4px;
            font-size: 14px;
          }
        }

        .charging {
          padding-top: 0px;
        }
        .outbound-balance {
          padding: 20px 0px 0px 32px;
          margin-bottom: 20px;
          .el-form-item__label {
            margin-right: 20px;
            line-height: 1;
          }
          .el-form-item__content {
            line-height: 1;
          }
          .el-form-item__error {
            padding-top: 0px;
          }
          .el-radio-group {
            .el-radio__input.is-disabled .el-radio__inner {
              background-color: white;
              border-color: #DDE1E7;
            }
            .el-radio__input.is-disabled.is-checked:hover {
              border-color: #DDE1E7;
            }

            .el-radio__input.is-disabled.is-checked .el-radio__inner,
            .el-radio__inner:hover,
            .el-radio__input.is-checked .el-radio__inner {
              background-color: white;
              border-color: #2E68EA;
            }

            .el-radio__input.is-disabled.is-checked .el-radio__inner::after,
            .el-radio__inner::after {
              background-color: #2E68EA;
            }

            .el-radio__input.is-checked+.el-radio__label {
              color: #2E68EA;
            }
          }
        }
        .default-header {
          width: 294px;
          padding: 0px 0px 0px 32px;
          margin-bottom: 20px;
          .el-form-item__label {
            width: 100%;
            text-align: left;
          }
          .el-form-item__content {
            width: 100%;
            .el-select {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
.select-popover-class {
  .el-scrollbar__wrap {
    min-width: 204px;
    .el-select-dropdown__list {
      padding: 6px 4px;
    }
    .el-select-dropdown__item {
      padding: 0px;
      display: flex;
      justify-content: space-between;
      .el-checkbox {
        padding: 0px 6px;
        flex: 1;
        .el-checkbox__label {
          padding-left: 4px;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
          font-family: 'PingFang SC-Regular';
        }
        .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #2E68EA;
          border-color: #2E68EA;
        }
        .el-checkbox__inner:hover {
          border-color: #2E68EA;
        }
        .el-checkbox__input.is-disabled .el-checkbox__inner::after {
          border-color: #fff;
        }
        .el-checkbox__input.is-disabled .el-checkbox__inner {
          background-color: #EBEEF5;
          border-color: #EBEEF5;
        }
      }
      .set-default {
        font-family: 'PingFang SC-Regular';
        font-weight: 400;
        font-size: 12px;
        padding-right: 6px;
        color: #2E68EA;
      }
    }
  }
  
  /* 隐藏多选框勾中样式 */
  .el-scrollbar__view>li::after {
    display: none;
  }
}
</style>
